import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { mapValues } from 'lodash';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
import { getZapierTemplateIntegrationTexts } from './zapierTemplateIntegrationTexts';
export const GetZapierTemplateDescriptionTID = (parentTestId)=>getTestIds(parentTestId);
const { ZapierTemplateDescriptionTID } = GetZapierTemplateDescriptionTID();
// WHY: the locale renderer injects the tag's text as children — dropping them renders an empty link
function DescriptionLink(param) {
    let { integration, tag, href, children } = param;
    return /*#__PURE__*/ _jsx(ExternalLinkButton, {
        openInNewTab: true,
        href: href,
        bi: {
            name: 'zapier_templates_page_link',
            data: {
                integration: integration.key,
                link: tag
            }
        },
        testId: ZapierTemplateDescriptionTID.Link(integration.key, tag),
        children: children
    });
}
// WHY: a tag not linked by this integration is never embedded in its description's locale string,
// so its inert placeholder is never rendered.
const INERT_EMBED = /*#__PURE__*/ _jsx(_Fragment, {});
export function ZapierTemplateDescription(param) {
    let { integration } = param;
    const { t: zapierTemplatesTexts } = useLocaleKeys('integrations.apps.zapierTemplates');
    const texts = getZapierTemplateIntegrationTexts(zapierTemplatesTexts, integration.i18nKey);
    const embeds = _object_spread({
        readMore: INERT_EMBED,
        instructions: INERT_EMBED,
        notionTemplate: INERT_EMBED
    }, mapValues(integration.descriptionLinks, (href, tag)=>/*#__PURE__*/ _jsx(DescriptionLink, {
            integration: integration,
            tag: tag,
            href: href
        })));
    return texts.description(embeds);
}
